<template>
	<div>
		<div v-if="isFirstPage">
			<div style="margin-top: 10px;" class="cardDivClass" v-if="!isBrand">
				<el-row :gutter="12">
				  <el-col :span="8">
				    <div>
				    	<el-card shadow="hover" style="border-top:3px solid #0099FB;">
				    		<div slot="header">
	    						<span>运营商总数</span>
						    </div>
						  	<div class="text item">
						  		<div style="font-size: 24px;">
						  			<span>{{mtotalChildAgent}}人</span>
						  		</div>
						    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
						    		<span>运营商</span>
						    	</div>
						  	</div>
					    </el-card>
				    </div>
				  </el-col>
				  <el-col :span="8">
				  	<div>
				  		<el-card shadow="hover" style="border-top:3px solid #52C41A;">
				    		<div slot="header">
	    						<span>运营商开单总数</span>
						    </div>
						  	<div>
						  		<div style="font-size: 24px;">
						  			<span>{{mopenAccountNum}}单</span>
						  		</div>
						    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
						    		<span>运营商</span>
						    	</div>
						  	</div>
					    </el-card>
				  	</div>
				  </el-col>
				  <el-col :span="8">
				  	<div>
				  		<el-card shadow="hover" style="border-top:3px solid #F5222D;">
				    		<div slot="header">
	    						<span>运营商设备总数</span>
						    </div>
						  	<div>
						  		<div style="font-size: 24px;">
						  			<span>{{mtotalDevice}}台</span>
						  		</div>
						    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
						    		<span>运营商</span>
						    	</div>
						  	</div>
					    </el-card>
				  	</div>
				  </el-col>
				</el-row>
			</div>
			<div style="margin-top: 25px;">
				<el-row  :gutter="12">
					<el-col :span="6">
						<el-button @click="openDialog" type="primary" v-if="isBrand">新建运营商</el-button>
					<!--	<el-select v-model="optionMethod" @change="optionChange" v-if="isBrand" style="width: 80px;margin-left: 3px;" placeholder="更多">
							<el-option label="删除" value="1"></el-option>
							<el-option label="修改" value="2"></el-option>
						</el-select>-->
					</el-col>
					<el-col :span="isBrand?18:24">
						<div style="width: 100%;text-align: right;">
							<!--<el-select v-model="level" style="width: 120px;" v-if="isBrand">
								<el-option label="全部代理商" value="0"></el-option>
								<el-option label="一级代理商" value="3"></el-option>
								<el-option label="二级代理商" value="2"></el-option>
								<el-option label="三级代理商" value="8"></el-option>
							</el-select>-->
							<el-select style="width: 110px;margin-left: 3px;" v-model="selectValue" placeholder="请选择">
								<el-option label="运营商id" value="1"></el-option>
								<el-option label="公司名" value="2"></el-option>
								<el-option label="运营商名" value="4"></el-option>
							</el-select>
							<el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" placeholder="请输入"></el-input>
							<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
						</div>
					</el-col>
				</el-row>
			</div>
			<div style="margin-top: 15px;">
				<el-table ref="multipleTable"
				 :data="tableData"
				 style="width: 100%"
				 element-loading-text="数据正在加载中"
				 @selection-change="handleSelectionChange"
				 :header-cell-style="headClass"
			 	 :row-style="rowClass">
		      <el-table-column type="selection" width="60"></el-table-column>
		      <el-table-column prop="agentId" label="运营商id" sortable></el-table-column>
		      <!--<el-table-column prop="level" label="级别"></el-table-column>-->
		      <el-table-column prop="companyName" label="公司名称"></el-table-column>
		      <el-table-column prop="name" label="管理员姓名"></el-table-column>
		      <el-table-column label="上级代理商">
		      	<template  slot-scope="scope">
		      		<div>
		      			<div v-if="scope.row.parentAgentName != '' && scope.row.parentAgentName != null">
		      				<el-tooltip class="item" effect="dark" :content="'代理商ID:'+scope.row.parentAgentId" placement="right">
							    <span>{{scope.row.parentAgentName}}</span>
							</el-tooltip>
		      			</div>
		      			<div v-else>
		      				<span>-</span>
		      			</div>
		      		</div>
		      	</template>
		      </el-table-column>
		   <!--   <el-table-column prop="totalChildAgent" label="下级代理商数" v-if="isBrand"></el-table-column>-->
		      <!--<el-table-column prop="openAccountNum" label="开单数"></el-table-column>-->
		      <el-table-column prop="totalDevices" label="设备数"></el-table-column>
		      <el-table-column prop="salesVolume" label="销量"></el-table-column>
		      <el-table-column prop="deposit" label="设备押金"></el-table-column>
		      <el-table-column prop="wallet" label="余额"></el-table-column>
		      <el-table-column label="操作">
		      	<template slot-scope="scope">
		      		<button @click="checkChild(scope.row.agentId)" v-if="isBrand">查看</button>
		      	</template>
		      </el-table-column>
		    </el-table>
		    <el-pagination background
	    			style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
		            @size-change="handleSizeChange"
		            @current-change="handleCurrentChange"
		            :current-page="currentPage"
		            :page-sizes="[10, 50, 100, 200]"
		            :page-size="pageSize"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total">
		    </el-pagination>
			</div>
		</div>
		<div v-if="!isFirstPage">
			<div>
				<i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">返回</i>
				<span style="margin-left: 20px;font-size: 18px;">{{childCompanyName}}/{{childAdminName}}/{{childAgentCategoryName}}</span>
				<i class="el-icon-edit-outline" style="font-size: 20px;cursor:pointer;margin-left: 20px;color: #0099FB;" @click="updateDialog"></i>
			</div>
			<div style="margin-top: 20px;">
				<el-row :gutter="12">
					<el-col :span="childLevel == '3'?4:6">
					    <div @click="queryClick(0)">
					    	<el-card shadow="hover" style="border-top:3px solid #0099FB;">
						      	<div slot="header">
		    						<span>设备</span>
							    </div>
							  	<div class="text item">
							  		<div style="font-size: 24px;">
							  			<span>{{totalDevice}}台</span>
							  		</div>
							    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
							    		<span>总设备</span>
							    	</div>
							  	</div>
						    </el-card>
					    </div>
					 </el-col>
					 <el-col :span="childLevel == '3'?5:6">
					    <div @click="queryClick(1)">
					    	<el-card shadow="hover" style="border-top:3px solid #A0D911;">
						      	<div slot="header">
		    						<span>开单</span>
							    </div>
							  	<div class="text item">
							  		<div style="font-size: 24px;">
							  			<span>{{openAccountNum}}单</span>
							  		</div>
							    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
							    		<span>开单数</span>
							    	</div>
							  	</div>
						    </el-card>
					    </div>
					 </el-col>
					 <el-col :span="childLevel == '3'?5:6">
					    <div @click="queryClick(2)">
					    	<el-card shadow="hover" style="border-top:3px solid #FADB14;">
						      	<div slot="header">
		    						<span>余额</span>
							    </div>
							  	<div class="text item">
							  		<div style="font-size: 24px;">
							  			<span>{{wallet}}元</span>
							  		</div>
							    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
							    		<span>钱包余额</span>
							    	</div>
							  	</div>
						    </el-card>
					    </div>
					 </el-col>
					<!-- <el-col :span="5" v-if="childLevel == '3'">
					    <div @click="queryClick(3)">
					    	<el-card shadow="hover" style="border-top:3px solid #FA541C;">
						      	<div slot="header">
		    						<span>代理商</span>
							    </div>
							  	<div class="text item">
							  		<div style="font-size: 24px;">
							  			<span>{{totalChildAgent}}人</span>
							  		</div>
							    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
							    		<span>代理商数量</span>
							    	</div>
							  	</div>
						    </el-card>
					    </div>
					 </el-col>-->
					 <el-col :span="childLevel == '3'?5:6">
					    <div @click="queryClick(4)">
					    	<el-card shadow="hover" style="border-top:3px solid #EB2F96;">
						      	<div slot="header">
		    						<span>销量</span>
							    </div>
							  	<div class="text item">
							  		<div style="font-size: 24px;">
							  			<span>{{salesVolume}}元</span>
							  		</div>
							    	<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
							    		<span>总销量</span>
							    	</div>
							  	</div>
						    </el-card>
					    </div>
					 </el-col>
				</el-row>
			</div>
			<div style="margin-top: 25px;">
				<div v-if="isAgent">
					<el-table ref="agentTable"
					 :data="agentTableData"
					 key="agentTableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="agentTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
				      <el-table-column type="selection" width="60"></el-table-column>
				      <el-table-column prop="agentId" label="运营商id" sortable></el-table-column>
				      <el-table-column prop="level" label="级别"></el-table-column>
				      <el-table-column prop="companyName" label="公司名称"></el-table-column>
				      <el-table-column prop="name" label="管理员姓名"></el-table-column>
				      <el-table-column label="上级代理商">
				      	<template  slot-scope="scope">
				      		<div>
				      			<div v-if="scope.row.parentAgentName != '' && scope.row.parentAgentName != null">
				      				<el-tooltip class="item" effect="dark" :content="'代理商ID:'+scope.row.parentAgentId" placement="right">
									    <span>{{scope.row.parentAgentName}}</span>
									</el-tooltip>
				      			</div>
				      			<div v-else>
				      				<span>-</span>
				      			</div>
				      		</div>
				      	</template>
				      </el-table-column>
				      <el-table-column prop="totalChildAgent" label="下级代理商总数"></el-table-column>
				      <el-table-column prop="totalDevices" label="设备总数"></el-table-column>
				      <el-table-column prop="deposit" label="设备押金"></el-table-column>
				      <el-table-column prop="wallet" label="余额"></el-table-column>
				      <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="checkSecondChild(scope.row.agentId)">查看</button>
				      	</template>
				      </el-table-column>
				    </el-table>
				</div>
				<div v-if="isDevice">
					<el-table ref="deviceTable"
					 :data="deviceTableData"
					 key="deviceTableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="deviceTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
				      <el-table-column type="selection" width="60"></el-table-column>
				      <el-table-column prop="sn" label="设备条形码" sortable></el-table-column>
				      <el-table-column prop="model" label="设备型号"></el-table-column>
				      <el-table-column prop="companyName" label="客户名称"></el-table-column>
				      <el-table-column prop="online" label="在线状态"></el-table-column>
				      <el-table-column prop="activationDate" label="激活时间" :formatter="dateFormat"></el-table-column>
				      <el-table-column prop="expires" label="到期时间" :formatter="dateFormat"></el-table-column>
				      <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="getMessage(scope.row.nid)">查看</button>
				      	</template>
				      </el-table-column>
				    </el-table>
				</div>
				<div v-if="isMoney">
					<el-table ref="moneyTable"
					 :data="moneyTableData"
					 key="moneyTableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="moneyTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
				      <el-table-column type="selection" width="60"></el-table-column>
					    <el-table-column prop="subject" label="订单商品名" sortable></el-table-column>
					    <el-table-column label="账单类型">
					    	<template slot-scope="scope">
					      		<div>
					      			<span v-if="scope.row.payType == 1001">购买</span>
					      			<span v-if="scope.row.payType == 1002">充值</span>
					      			<span v-if="scope.row.payType == 1003">提现</span>
					      			<span v-if="scope.row.payType == 1004">分红</span>
					      		</div>
					      	</template>
					    </el-table-column>
					    <el-table-column label="付款人类型">
					    	<template slot-scope="scope">
					      		<div>
					      			<span v-if="scope.row.roleType == 1">客户</span>
									<span v-if="scope.row.roleType == 8">三级代理商</span>
					      			<span v-if="scope.row.roleType == 2">二级代理商</span>
					      			<span v-if="scope.row.roleType == 3">一级代理商</span>
					      			<span v-if="scope.row.roleType == 4">品牌商</span>
                                    <span v-if="scope.row.roleType == 9">运营商</span>
					      		</div>
					      	</template>
					    </el-table-column>
					    <el-table-column prop="nickName" label="付款人"></el-table-column>
					    <el-table-column prop="amount" label="付款金额"></el-table-column>
					    <el-table-column prop="paytime" label="完成时间" :formatter="dateFormat"></el-table-column>
					    <el-table-column prop="payId" label="支付交易号"></el-table-column>
				      <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="getMessage(scope.row.money)">查看</button>
				      	</template>
				      </el-table-column>
				    </el-table>
				</div>
				<div v-if="isAccount">
					<el-table ref="accountTable"
					 :data="accountTableData"
					 key="accountTableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="accountTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
				      <el-table-column type="selection" width="60"></el-table-column>
				      <el-table-column prop="id" label="开单号" sortable></el-table-column>
				      <el-table-column prop="adminName" label="代理商"></el-table-column>
				      <el-table-column label="状态">
				      	<template slot-scope="scope">
				      		<div>
				      			<span v-if="scope.row.status == 1">审批中</span>
				      			<span v-if="scope.row.status == 2">审批通过</span>
				      			<span v-if="scope.row.status == 3">审批拒绝</span>
				      			<span v-if="scope.row.status == 4">已发货</span>
				      		</div>
				      	</template>
				      </el-table-column>
				      <el-table-column prop="customerName" label="客户名称"></el-table-column>
				      <el-table-column prop="contact" label="联系人"></el-table-column>
				      <el-table-column prop="contactNumber" label="联系电话"></el-table-column>
				      <el-table-column label="安装地址">
				      	<template slot-scope="scope">
				      		<div>
				      			{{scope.row.province}} {{scope.row.city}} {{scope.row.district}} {{scope.row.address}}
				      		</div>
				      	</template>
				      </el-table-column>
				      <el-table-column prop="posttime" label="开单日期" :formatter="dateFormat"></el-table-column>
				      <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="getMessage(scope.row.id)">查看</button>
				      	</template>
				      </el-table-column>
				    </el-table>
				</div>
				<div v-if="isSale">
					<el-table ref="saleTable"
					 :data="saleTableData"
					 key="saleTableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="saleTableChange"
					 :header-cell-style="headClass"
				 	 :row-style="rowClass">
				      <el-table-column type="selection" width="60"></el-table-column>
				      <el-table-column prop="agentId" label="代理商ID" sortable></el-table-column>
				      <el-table-column prop="name" label="代理商"></el-table-column>
				      <el-table-column prop="relation" label="关系"></el-table-column>
				      <el-table-column prop="money" label="充值金额"></el-table-column>
				      <el-table-column prop="posttime" label="充值时间" :formatter="dateFormat"></el-table-column>
				      <el-table-column prop="serialNumber" label="单号"></el-table-column>
				      <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="getMessage(scope.row.money)">查看</button>
				      	</template>
				      </el-table-column>
				    </el-table>
				</div>
			    <el-pagination background
		    			style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
			            @size-change="tableSizeChange"
			            @current-change="tablePageChange"
			            :current-page="tablePage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="tableSize"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="tableTotal">
			    </el-pagination>
			</div>
		</div>
		<el-dialog title="新建运营商" :visible.sync="myDialog" width="620px" :close-on-click-modal="false">
			<el-form label-position="right" label-width="110px" ref="agentNewForm" :rules="agentNewRules" :model="agentNewForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label="运营商公司名" prop="companyName">
		    				<el-input v-model="agentNewForm.companyName" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>
				<!--	<el-col :span="12">
						<el-form-item label="代理商级别" prop="myselect">
		    				<el-select v-model="agentNewForm.myselect" style="width: 150px;" @change="newSelectChange">
								<el-option value="3" label="一级代理商"></el-option>
								<el-option value="2" label="二级代理商"></el-option>
								<el-option value="8" label="三级代理商"></el-option>
							</el-select>
		  				</el-form-item>
					</el-col>-->
          <el-col :span="12" >
            <el-form-item label="上级代理商" prop="superiorAgent">
              <el-select v-model="agentNewForm.superiorAgent" style="width: 150px;">
                <el-option :value="item.agentId" :label="item.companyName" style="height: 40px;font-size: 11px;padding: 0;" v-for="item in superiorAgentList">
                  <el-row style="height: 20px;font-size: 10px;">
                    <el-col :span="24" style="line-height: 20px;height: 20px;">{{item.companyName}}</el-col>
                  </el-row>
                  <el-row style="height: 20px;">
                    <el-col :span="10" style="line-height: 20px;height: 20px;">{{item.name}}</el-col>
                    <el-col :span="14" style="line-height: 20px;height: 20px;">{{item.phone}}</el-col>
                  </el-row>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="管理员姓名" prop="name">
		    				<el-input v-model="agentNewForm.name" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运营商类型" prop="categoryId">
		    				<el-select v-model="agentNewForm.categoryId" style="width: 150px;">
								<el-option v-for="item in categoryList" :value="item.categoryId" :label="item.name"></el-option>
							</el-select>
		  				</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="管理员电话" prop="phone">
		    				<el-input v-model="agentNewForm.phone" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>
				<!--	<el-col :span="12">
						<el-form-item label="7天试用权限" prop="isSevenDay">
		    				<el-select v-model="agentNewForm.isSevenDay" style="width: 150px;">
								<el-option value="0" label="无权限"></el-option>
								<el-option value="1" label="有权限"></el-option>
							</el-select>
		  				</el-form-item>
					</el-col>-->
				</el-row>
				<!-- <el-row>
					<el-col :span="12">
						<el-popover
						    ref="popover"
						    placement="top"
						    width="222"
						    trigger="focus"
						    :content="initMoney">
						</el-popover>
						<el-form-item label="货款" prop="rentalFees">
		    				<el-input v-model="agentNewForm.rentalFees" style="width: 180px;" v-popover:popover></el-input>
		  				</el-form-item>
					</el-col>

				</el-row>
				<el-row style="margin-top: 15px;">
					<el-col :span="12">
						<el-popover
						    ref="popover1"
						    placement="top"
						    width="222"
						    trigger="focus"
						    :content="initMoney1">
						</el-popover>
						<el-form-item label="押金" prop="deposit">
		    				<el-input v-model="agentNewForm.deposit" style="width: 180px;" v-popover:popover1></el-input>
		  				</el-form-item>
					</el-col>
				</el-row> -->
				<el-row>
					<el-col :span="12">
						<el-form-item label="运营商地址" prop="address">
		    				<el-input v-model="agentNewForm.address" type="textarea" :rows="3" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="newAgent">创建运营商</el-button>
			</div>
		</el-dialog>
		<el-dialog title="修改运营商" :visible.sync="myDialog1" width="620px" :close-on-click-modal="false">
			<el-form label-position="right" label-width="110px" ref="agentUpdateForm" :rules="agentUpdateRules" :model="agentUpdateForm">
				<el-row>
					<el-col :span="12">
						<el-form-item label="运营商公司名" prop="companyName">
		    				<el-input v-model="agentUpdateForm.companyName" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>
				<!--	<el-col :span="12">
						<el-form-item label="代理商级别" prop="myselect">
		    				<el-select v-model="agentUpdateForm.myselect" style="width: 150px;" @change="UpdateSelectChange">
								<el-option value="3" label="一级代理商"></el-option>
								<el-option value="2" label="二级代理商"></el-option>
								<el-option value="8" label="三级代理商"></el-option>
							</el-select>
		  				</el-form-item>
					</el-col>-->
          <el-col :span="12">
            <el-form-item label="运营商类型" prop="categoryId">
              <el-select v-model="agentUpdateForm.categoryId" style="width: 150px;">
                <el-option v-for="item in categoryList" :value="item.categoryId" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="管理员姓名" prop="name">
		    				<el-input v-model="agentUpdateForm.name" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>
          <el-col :span="12" >
            <el-form-item label="上级代理商" prop="superiorAgent">
              <el-select v-model="agentUpdateForm.superiorAgent" style="width: 150px;">
                <el-option :value="item.agentId" :label="item.companyName" style="height: 40px;font-size: 11px;" v-for="item in superiorAgentList">
                  <el-row style="height: 20px;font-size: 10px;">
                    <el-col :span="24" style="line-height: 20px;height: 20px;">{{item.companyName}}</el-col>
                  </el-row>
                  <el-row style="height: 20px;">
                    <el-col :span="8" style="line-height: 20px;height: 20px;">{{item.name}}</el-col>
                    <el-col :span="16" style="line-height: 20px;height: 20px;">{{item.phone}}</el-col>
                  </el-row>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="管理员手机号" prop="phone">
							<span>{{agentUpdateForm.phone}}</span>
						</el-form-item>
					</el-col>
					<!--<el-col :span="12">
						<el-form-item label="7天试用权限" prop="isSevenDay">
		    				<el-select v-model="agentUpdateForm.isSevenDay" style="width: 150px;">
								<el-option value="0" label="无权限"></el-option>
								<el-option value="1" label="有权限"></el-option>
							</el-select>
		  				</el-form-item>
					</el-col>-->
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="运营商地址" prop="address">
		    				<el-input v-model="agentUpdateForm.address" type="textarea" :rows="3" style="width: 180px;"></el-input>
		  				</el-form-item>
					</el-col>

				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="updateAgent">修改运营商</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'agentType',
  components: {
  },
  data() {
  	var validMoney = (rule, value, callback) => {
  		var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
		var temp = (value.toString().indexOf(".")!=-1)?value.toString().substring(0,value.toString().indexOf(".")):value;
		if(value > 0){
			for(var i = 0;i < this.categoryList.length;i++){
				if(this.categoryList[i].categoryId == this.agentNewForm.categoryId){
					if(value < this.categoryList[i].initialFunding){
						callback(new Error('输入金额应大于等于首次最低租赁款'+this.categoryList[i].initialFunding+'元!'));
						break;
					}
				}
			}
		}
		if(temp.length >= 10){
			callback(new Error('输入金额不应大于10亿!'));
		}else if(value <= 0){
			callback(new Error('输入金额应大于0元!'));
		}else if((value.toString().charAt(0) == '0' && value.indexOf(".") != 1)  || !regPos.test(value) || value.indexOf(".") == value.length-1){
			callback(new Error('请输入正确格式的金额!金额最多保留两位小数.'));
		}else{
			callback();
		}
	}
  	var validMoney1 = (rule, value, callback) => {
  		var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
		var temp = (value.toString().indexOf(".")!=-1)?value.toString().substring(0,value.toString().indexOf(".")):value;
		if(temp.length >= 10){
			callback(new Error('输入金额不应大于10亿!'));
		}else if(value <= 0){
			callback(new Error('输入金额应大于0元!'));
		}else if((value.toString().charAt(0) == '0' && value.indexOf(".") != 1)  || !regPos.test(value) || value.indexOf(".") == value.length-1){
			callback(new Error('请输入正确格式的金额!金额最多保留两位小数.'));
		}else{
			callback();
		}
	}
  	var validPhone = (rule, value, callback) => {
  		var regPos = /^1[0-9][0-9]{9}$/;
		if(!regPos.test(value)){
			callback(new Error('手机号格式有误!'));
		}else{
			callback();
		}
	}
  	var validSuperiorAgent = (rule, value, callback) => {
  		if(this.agentNewForm.myselect == "2"){
  			if(value.toString() === ""){
  				callback(new Error("请选择运营商的上级代理商!"));
  			}else{
  				callback();
  			}
  		}else{
  			callback();
  		}
	}
  	var validSuperiorAgent1 = (rule, value, callback) => {
  		if(this.agentUpdateForm.myselect == "2"){
  			if(value.toString() === ""){
  				callback(new Error("请选择运营商的上级代理商!"));
  			}else{
  				callback();
  			}
  		}else{
  			callback();
  		}
	}
    return {
    	agentName:'',
    	myDialog:false,
    	total: 0,
        currentPage: 1,
　　  	pageSize: 10,
		multipleSelection:[],
		tableData:[],
		categoryList:[],
		superiorAgentList:[],
		agentNewForm:{
			isSevenDay:'',
			companyName:'',
			deposit:'',
			name:'',
			phone:'',
			address:'',
			rentalFees:'',
			myselect:"3",
			superiorAgent:"",
			categoryId:""
		},
		agentNewRules:{
			//isSevenDay:[{ trigger: 'change',required: true, message: '请选择代理商是否有7天试用权限!'}],
			companyName:[{ trigger: 'blur',required: true, message: '运营商公司名不能为空!'}],
			deposit:[{ trigger: 'blur',required: true, message: '金额不能为空!'},{ trigger: 'blur',validator: validMoney1}],
			name:[{ trigger: 'blur',required: true, message: '运营商管理员姓名不能为空!'}],
			phone:[{ trigger: 'blur',required: true, message: '运营商管理员手机号不能为空!'},{ trigger: 'blur',validator: validPhone}],
			address:[{ trigger: 'blur',required: true, message: '地址不能为空!'}],
			rentalFees:[{ trigger: 'blur',required: true, message: '金额不能为空!'},{ trigger: 'blur',validator: validMoney}],
			myselect:[{ trigger: 'change',required: true, message: '请选择运营商级别!'}],
			superiorAgent:[{ trigger: 'change',validator: validSuperiorAgent}],
			categoryId:[{ trigger: 'change',required: true, message: '请选择运营商的类型!'}]
		},
		agentUpdateForm:{
			isSevenDay:'',
			companyName:'',
			phone:'',
			name:'',
			address:'',
			myselect:"3",
			superiorAgent:"",
			categoryId:""
		},
		agentUpdateRules:{
			isSevenDay:[{ trigger: 'change',required: true, message: '请选择运营商是否有7天试用权限!'}],
			companyName:[{ trigger: 'blur',required: true, message: '运营商公司名不能为空!'}],
			name:[{ trigger: 'blur',required: true, message: '运营商管理员姓名不能为空!'}],
			address:[{ trigger: 'blur',required: true, message: '地址不能为空!'}],
			myselect:[{ trigger: 'change',required: true, message: '请选择运营商级别!'}],
			superiorAgent:[{ trigger: 'change',validator: validSuperiorAgent1}],
			categoryId:[{ trigger: 'change',required: true, message: '请选择运营商的类型!'}]
		},
		myDialog1:false,
		queryValue:'',
		selectValue:'',
		level:"0",
		optionMethod:"",
		isBrand:false,
		isFirstPage:true,
		mtotalChildAgent:0,
		mtotalDevice:0,
		mopenAccountNum:0,
		salesVolume:0,
		totalChildAgent:0,
		totalDevice:0,
		openAccountNum:0,
		wallet:0,
		isAgent:false,
		agentSelection:[],
		agentTableData:[],
		isDevice:true,
		deviceSelection:[],
		deviceTableData:[],
		isMoney:false,
		moneySelection:[],
		moneyTableData:[],
		isAccount:false,
		accountSelection:[],
		accountTableData:[],
		isSale:false,
		saleSelection:[],
		saleTableData:[],
		tableTotal:0,
		tablePage:1,
		tableSize:10,
		childCompanyName:'',
		childAdminName:'',
		childAgentCategoryName:'',
		childLevel:'',
		firstChildId:'',
		agentId:''
    }
  },
  watch: {
  },
  computed:{
  	initMoney:function(){
  		var money = "0.00";
  		var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
  		if(this.agentNewForm.rentalFees != ""){
  			if(regPos.test(this.agentNewForm.rentalFees)){
  				var intPart = Number(Math.floor(this.agentNewForm.rentalFees));
  				var valueArray = this.agentNewForm.rentalFees.toString().split(".");
  				if(intPart.toString().length < 10){
  					if(valueArray.length == 2){
	  					var floatPart = valueArray[1].toString();
	  					if(floatPart.length == 1){
	  						money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + floatPart + "0";
	  					}else if(floatPart.length == 2){
	  						money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + floatPart;
	  					}else{
				  			return "您输入的金额格式有误!"
				  		}
	  				}else{
	  					money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ".00";
	  				}
  				}else{
		  			return "您输入的金额格式有误!"
		  		}
  			}else{
	  			return "您输入的金额格式有误!"
	  		}
  		}
  		return "您输入金额:"+money+"元";
  	},
  	initMoney1:function(){
  		var money = "0.00";
  		var regPos = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/;
  		if(this.agentNewForm.deposit != ""){
  			if(regPos.test(this.agentNewForm.deposit)){
  				var intPart = Number(Math.floor(this.agentNewForm.deposit));
  				var valueArray = this.agentNewForm.deposit.toString().split(".");
  				if(intPart.toString().length < 10){
  					if(valueArray.length == 2){
	  					var floatPart = valueArray[1].toString();
	  					if(floatPart.length == 1){
	  						money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + floatPart + "0";
	  					}else if(floatPart.length == 2){
	  						money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + "." + floatPart;
	  					}else{
				  			return "您输入的金额格式有误!"
				  		}
	  				}else{
	  					money = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + ".00";
	  				}
  				}else{
		  			return "您输入的金额格式有误!"
		  		}
  			}else{
	  			return "您输入的金额格式有误!"
	  		}
  		}
  		return "您输入金额:"+money+"元";
  	}
  },
  mounted() {
  	this.initPage();
  	this.updateTable();
  },
  beforeDestroy() {
  },
  methods: {
  	initPage(){
  		var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do')
    		.then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	if(data.data.role == 4){
			    		thiz.isBrand = true;
			    	}else{
			    		thiz.getOverview();
			    	}
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
  	},
  	getOverview(){
  		var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsAgent/getAgentOverview.do',{
        params:{
          isOperator:1
    }})
    		.then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.mopenAccountNum = data.data.openAccountNum;
			    	thiz.mtotalChildAgent = data.data.totalChildAgent;
			    	thiz.mtotalDevice = data.data.totalDevice;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
  	},
  	//品牌商查看一级代理商详情页面查看二级代理商
  	checkSecondChild(agentId){
  		this.firstChildId = this.agentId;
  		this.checkChild(agentId);
  	},
  	//查看子代理商详情
  	checkChild(agentId){
  		this.agentId = agentId;
  		var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsAgent/getOtherAgentOverview.do',{
  			params:{
  				agentId:agentId
  			}
  		}).then(function (response) {
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.openAccountNum = data.data.openAccountNum;
		    	thiz.salesVolume = data.data.salesVolume;
		    	thiz.totalChildAgent = data.data.totalChildAgent;
		    	thiz.totalDevice = data.data.totalDevice;
		    	thiz.wallet = data.data.wallet;
		    	thiz.childCompanyName = data.data.companyName;
		    	thiz.childAdminName = data.data.adminName;
		    	thiz.childLevel = data.data.level;
		    	thiz.childAgentCategoryName = data.data.agentCategoryName;
		    	thiz.updateChildTable();
		    }else{
			    thiz.$message.error(data.message);
			}
		  }).catch(function (error) {
		  	thiz.$message.error("系统异常!请与管理员联系!");
		    console.log(error);
		  });
  	},
  	goback(){
  		this.isAgent = false;
		this.isDevice = true;
		this.isMoney = false;
		this.isAccount = false;
		this.isSale = false;
		if(this.childLevel == '2' && this.firstChildId != "" && this.firstChildId != null){
			this.checkChild(this.firstChildId);
			this.firstChildId = "";
		}else{
			this.isFirstPage = true;
			this.firstChildId = "";
		}
  	},
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    updateTable(){
    	var params = {
    		pageId:this.currentPage,
  			size:this.pageSize,
  			level:this.level,
        isOperator:1
    	};
    	if(this.selectValue == "1" && this.queryValue != ""){
    		params.agentId = this.queryValue;
    	}else if(this.selectValue == "2" && this.queryValue != ""){
    		params.companyName = this.queryValue;
    	}else if(this.selectValue == "3" && this.queryValue != ""){
    		params.level = this.queryValue;
    	}else if(this.selectValue == "4" && this.queryValue != ""){
    		params.name = this.queryValue;
    	}
    	var thiz = this;
    	const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	axios.get(this.$store.getters.getApiValue+'/srsAgent/searchMyAgentList.do',{
  			params:params
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }else{
		    	thiz.$message.error(data.message);
		    }
		  }).catch(function (error) {
		  	loading.close();
		  	thiz.$message.error("系统异常!请与管理员联系!");
		    console.log(error);
		  });
    },
    //新建代理商时代理商类型选择change事件，分别获取当前级别对应的代理商，同时如果是二级代理商类型也展示选择一级代理商
    newSelectChange(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/getAgentCategoryByLevel.do',{
    		params:{
    			level:9
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	if(data.data != null){
			    		thiz.categoryList = data.data;
			    	}
			    	thiz.myDialog = true;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
	/*	if(this.agentNewForm.myselect == "2"||this.agentNewForm.myselect == "8"){
			var level = 3;
			if(this.agentNewForm.myselect == "8") level = 2;*/
			this.agentNewForm.categoryId = "";
			axios.get(this.$store.getters.getApiValue+'/srsAgent/getPrimaryAgentList.do',{
				params:{
					level:9
				}})
				.then(function (response) {
				    var data = response.data;
				    if(data.status == "200"){
				    	if(data.data != null){
				    		thiz.superiorAgentList = data.data;
				    	}
				    	thiz.myDialog = true;
				    }else{
				    	thiz.$message.error(data.message);
				    }
				  }).catch(function (error) {
				  	thiz.$message.error("系统异常!请与管理员联系!");
				    console.log(error);
				  });

    },
    openDialog(){
    	this.agentNewForm.categoryId = '';
    	this.agentNewForm.companyName = '';
    	this.agentNewForm.deposit = '';
    	this.agentNewForm.address = '';
    	this.agentNewForm.name = '';
    	this.agentNewForm.phone = '';
    	this.agentNewForm.rentalFees = '';
    	this.agentNewForm.tryuse = "0";
    	this.categoryList = [];
    	this.agentNewForm.superiorAgent = "";
    	this.newSelectChange();
    },
    updateDialog(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsAgent/getAgentData.do',{
    		params:{
    			agentId:this.agentId
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.agentUpdateForm.myselect = data.data.level+'';
			    	thiz.agentUpdateForm.categoryId = data.data.categoryId;
			    	thiz.agentUpdateForm.companyName = data.data.companyName;
			    	thiz.agentUpdateForm.name = data.data.agentName;
			    	thiz.agentUpdateForm.address = data.data.location;
			    	thiz.agentUpdateForm.isSevenDay = data.data.tryuse+'';
			    	thiz.agentUpdateForm.phone = data.data.phone;
			    	thiz.agentUpdateForm.superiorAgent = data.data.parentAgentId==0?"":data.data.parentAgentId;
			    	thiz.UpdateInit();
			    }else{
			    	thiz.$message.error(data.message);
			    }
			}).catch(function (error) {
				thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			});
    },
    //更新代理商时代理商类型选择change事件，分别获取当前级别对应的代理商，同时如果是二级代理商类型也展示选择一级代理商
    //之所以做两个类似的方法，原因是因为更新获取代理商信息时，categoryId必然有值，若采用之前方法会清空categoryId，
    //为不影响展示，所以就提出来了。
    UpdateInit(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/getAgentCategoryByLevel.do',{
    		params:{
    			level:thiz.agentUpdateForm.myselect
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	if(data.data != null){
			    		thiz.categoryList = data.data;
			    	}
			    	thiz.myDialog1 = true;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		if(this.agentUpdateForm.myselect == "2"||this.agentUpdateForm.myselect == "8"){
			var level = 3;
			if(this.agentUpdateForm.myselect == "8") level = 2;
			axios.get(this.$store.getters.getApiValue+'/srsAgent/getPrimaryAgentList.do',{
				params:{
					level:level
				}})
				.then(function (response) {
				    var data = response.data;
				    if(data.status == "200"){
				    	if(data.data != null){
				    		thiz.superiorAgentList = data.data;
				    	}
				    	thiz.myDialog1 = true;
				    }else{
				    	thiz.$message.error(data.message);
				    }
				  }).catch(function (error) {
				  	thiz.$message.error("系统异常!请与管理员联系!");
				    console.log(error);
				  });
		}
    },
    UpdateSelectChange(){
    	var thiz = this;
    	axios.get(this.$store.getters.getApiValue+'/srsAgentCategory/getAgentCategoryByLevel.do',{
    		params:{
    			level:thiz.agentUpdateForm.myselect
    		}
    	}).then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	if(data.data != null){
			    		thiz.categoryList = data.data;
			    	}
			    	thiz.myDialog1 = true;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		if(this.agentUpdateForm.myselect == "2"||this.agentUpdateForm.myselect == "8"){
			var level = 3;
			if(this.agentUpdateForm.myselect == "8")level = 2;
			this.agentUpdateForm.categoryId = "";
			axios.get(this.$store.getters.getApiValue+'/srsAgent/getPrimaryAgentList.do',{
				params:{
					/*agentId:this.agentId,*/
					level:level
				}
			}).then(function (response) {
				    var data = response.data;
				    if(data.status == "200"){
				    	if(data.data != null){
				    		thiz.superiorAgentList = data.data;
				    	}
				    	thiz.myDialog1 = true;
				    }else{
				    	thiz.$message.error(data.message);
				    }
				  }).catch(function (error) {
				  	thiz.$message.error("系统异常!请与管理员联系!");
				    console.log(error);
				  });
		}
    },
    //更新
    updateAgent(){
    	if(this.isBrand){
    		var thiz = this;
    		this.$refs["agentUpdateForm"].validate(async valid => {
		        if (valid) {
		        	var params={
		        			agentId:this.agentId,
			    			categoryId:this.agentUpdateForm.categoryId,
			    			companyName:this.agentUpdateForm.companyName,
			    			location:this.agentUpdateForm.address,
			    			name:this.agentUpdateForm.name,
			    			tryuse:this.agentUpdateForm.isSevenDay,
                agent1 : this.agentUpdateForm.superiorAgent
			    		}
		    	/*	if(this.agentUpdateForm.myselect == "2"||this.agentUpdateForm.myselect == "8"){
		    			params.agent1 = this.agentUpdateForm.superiorAgent;
		    		}else{
		    			params.agent1 = "0";
		    		}*/
			    	axios.get(this.$store.getters.getApiValue+'/srsAgent/updateAgentData.do',{
			    		params:params
			    	}).then(function (response) {
						    var data = response.data;
						    if(data.status == "200"){
						    	thiz.$message.success("更新成功!");
						    	thiz.updateTable();
						    	thiz.myDialog1 = false;
						    }else{
								thiz.$message.error(data.message);
							}
						  }).catch(function (error) {
						    console.log(error);
						    thiz.$message.error("系统异常!请与管理员联系!");
						  });
		        } else {
		          this.$message.error("填写不完整或格式不正确，请确认！")
		        }
	      	})
    	}
    },
    //新建代理商
    newAgent(){
    	if(this.isBrand){
    		var thiz = this;
    		this.$refs["agentNewForm"].validate(async valid => {
		        if (valid) {
		        	var params={
			    			categoryId:this.agentNewForm.categoryId,
			    			companyName:this.agentNewForm.companyName,
			    			deposit:this.agentNewForm.deposit,
			    			location:this.agentNewForm.address,
			    			name:this.agentNewForm.name,
			    			phone:this.agentNewForm.phone,
			    			rentalFees:this.agentNewForm.rentalFees,
			    			tryuse:this.agentNewForm.isSevenDay,
                            agent1 : this.agentNewForm.superiorAgent
                        }
                    if(params.agent1==null||params.agent1==""){
                        params.agent1 = "0";
                    }
			    	axios.get(this.$store.getters.getApiValue+'/srsAgent/addAgent.do',{
			    		params:params
			    	}).then(function (response) {
						    var data = response.data;
						    if(data.status == "200"){
						    	thiz.$message.success("新增成功!");
						    	thiz.updateTable();
						    	thiz.myDialog = false;
						    }else{
								thiz.$message.error(data.message);
							}
						  }).catch(function (error) {
						    console.log(error);
						    thiz.$message.error("系统异常!请与管理员联系!");
						  });
		        } else {
		          this.$message.error("填写不完整或格式不正确，请确认！")
		        }
	      	})
    	}
    },
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	optionChange(){
		console.log(this.optionMethod);
	},
	//子代理商详情页面点击不同概览时展示不同的数据表
	queryClick(val){
		if(val === 3){
			this.isAgent = true;
			this.isDevice = false;
			this.isMoney = false;
			this.isAccount = false;
			this.isSale = false;
			this.agentSelection = [];
			this.agentTableData = [];
		}else if(val === 0){
			this.isAgent = false;
			this.isDevice = true;
			this.isMoney = false;
			this.isAccount = false;
			this.isSale = false;
			this.deviceSelection = [];
			this.deviceTableData = [];
		}else if(val === 2){
			this.isAgent = false;
			this.isDevice = false;
			this.isMoney = true;
			this.isAccount = false;
			this.isSale = false;
			this.moneySelection = [];
			this.moneyTableData = [];
		}else if(val === 1){
			this.isAgent = false;
			this.isDevice = false;
			this.isMoney = false;
			this.isAccount = true;
			this.isSale = false;
			this.accountSelection = [];
			this.accountTableData = [];
		}else if(val === 4){
			this.isAgent = false;
			this.isDevice = false;
			this.isMoney = false;
			this.isAccount = false;
			this.isSale = true;
			this.saleSelection = [];
			this.saleTableData = [];
		}
		this.tableTotal = 0;
		this.tablePage = 1;
		this.tableSize = 10;
		this.updateChildTable();
	},
	getMessage(val){
		alert(val);
	},
	dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getStandardDate(new Date(str));
		}
	},
	getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
   	},
	agentTableChange(val){
		this.agentSelection = val;
	},
	deviceTableChange(val){
		this.deviceSelection = val;
	},
	moneyTableChange(val){
		this.moneySelection = val;
	},
	accountTableChange(val){
		this.accountSelection = val;
	},
	saleTableChange(val){
		this.saleSelection = val;
	},
	tableSizeChange(val){
		this.tableSize = val;
		this.updateChildTable();
	},
	tablePageChange(val){
		this.tablePage = val;
		this.updateChildTable();
	},
	updateChildTable(){
		var params = {
			pageId:this.tablePage,
  			size:this.tableSize,
  			agentId:this.agentId
		}
		var thiz = this;
		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
		if(this.isAgent && !this.isDevice && !this.isMoney && !this.isAccount && !this.isSale){
	    	axios.get(this.$store.getters.getApiValue+'/srsAgent/searchOtherAgentList.do',{
	  			params:params
	  		}).then(function (response) {
	  			loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.tableTotal = data.totalCount;
			    	thiz.agentTableData = data.data;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	loading.close();
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		}else if(!this.isAgent && this.isDevice && !this.isMoney && !this.isAccount && !this.isSale){
			axios.get(this.$store.getters.getApiValue+'/srsDevice/searchOtherDevice.do',{
	  			params:params
	  		}).then(function (response) {
	  			loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.tableTotal = data.totalCount;
			    	thiz.deviceTableData = data.data;
			    	thiz.isFirstPage = false;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	loading.close();
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		}else if(!this.isAgent && !this.isDevice && this.isMoney && !this.isAccount && !this.isSale){
			axios.get(this.$store.getters.getApiValue+'/income/listBillings.do',{
	  			params:params
	  		}).then(function (response) {
	  			loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.tableTotal = data.totalCount;
			    	thiz.moneyTableData = data.data;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	loading.close();
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		}else if(!this.isAgent && !this.isDevice && !this.isMoney && this.isAccount && !this.isSale){
			params.inputAgentId = this.agentId;
			params.status = "2,4";
			axios.get(this.$store.getters.getApiValue+'/application/searche.do',{
	  			params:params
	  		}).then(function (response) {
	  			loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.tableTotal = data.totalCount;
			    	thiz.accountTableData = data.data;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	loading.close();
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		}else if(!this.isAgent && !this.isDevice && !this.isMoney && !this.isAccount && this.isSale){
			axios.get(this.$store.getters.getApiValue+'/srsAgent/searchSalesList.do',{
	  			params:params
	  		}).then(function (response) {
	  			loading.close();
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.tableTotal = data.totalCount;
			    	thiz.saleTableData = data.data;
			    }else{
			    	thiz.$message.error(data.message);
			    }
			  }).catch(function (error) {
			  	loading.close();
			  	thiz.$message.error("系统异常!请与管理员联系!");
			    console.log(error);
			  });
		}
	}
  }
}
</script>

<style>
	.el-table{
  	font-size: 12px;
  	border-bottom: 1px solid #dcd8d8;
  	color: black;
  }
  .el-table tr th{
  	border-top: 0px;
  	border-left: 0px;
  	border-right: 0px;
  }
  .el-table tr td{
  	border-bottom: 1px solid #dcd8d8;
  }
</style>
